export default "__VITE_ASSET__BM3couoh__"